import React from "react";
import { Route } from "react-router-dom";
import { CanAccessThisPage } from "Common/RoleVerify";

import Tuning from "Tuning/Configuration/Components/Tuning/Tuning";
import CommonSettings from "Tuning/CommonSettings/CommonSettings";
import PaymentSettings from "Tuning/Configuration/Components/Tuning/Components/PaymentSettings/PaymentSettings";
import AccountSettings from "Tuning/Configuration/Components/Tuning/Components/AccountSettings/AccountSettings";
import Apps from "Tuning/Configuration/Components/Tuning/Components/Apps/Apps";
import Inbox from "Tuning/Configuration/Components/Tuning/Components/Apps/Components/Inbox/Inbox";
import Chat from "Tuning/Configuration/Components/Tuning/Components/Apps/Components/Chat/Chat";
import Calendar from "Tuning/Configuration/Components/Tuning/Components/Apps/Components/Calendar/Calendar";
import FileManager from "Tuning/Configuration/Components/Tuning/Components/Apps/Components/FileManager/FileManager";
import Changelog from "Tuning/Configuration/Components/Tuning/Components/Apps/Components/Changelog/Changelog";
import AboutUs from "Tuning/FrontPages/AboutUs/AboutUs";
import ContactUs from "Tuning/FrontPages/ContactUs/ContactUs";
import PrivacyPolicy from "Tuning/FrontPages/PrivacyPolicy/PrivacyPolicy";
import TermsConditions from "Tuning/FrontPages/TermsConditions/TermsConditions";
import SearchPage from "Tuning/Pages/SearchPage/SearchPage";

import UserAdd from "Tuning/UserManagement/UserAdd/UserAdd";
import UserEdit from "Tuning/UserManagement/EditUser/UserEdit";
import RoleAdd from "Tuning/RoleManagement/RoleList/AddRole/AddRole";
import RoleEdit from "Tuning/RoleManagement/RoleList/EditRole/EditRole";
import MenuEdit from "Tuning/SystemSettings/FrontMenu/MenuEdit/MenuEdit";
import CurrencyEdit from "Tuning/SystemSettings/CurrencySetting/CurrencyEdit/CurrencyEdit";
import CurrencyAdd from "Tuning/SystemSettings/CurrencySetting/CurrencyAdd/CurrencyAdd";
import LanguageEdit from "Tuning/Localization/Language/LanguageEdit/LanguageEdit";
import AddTeamMember from "Tuning/WebsiteSettings/TeamMembers/AddTeamMember/AddTeamMeber";
import TeamMemberEdit from "Tuning/WebsiteSettings/TeamMembers/TeamMemberEdit/TeamMemberEdit";
import AddGallery from "Tuning/WebsiteSettings/Gallery/AddGallery/AddGallery";
import EditGallery from "Tuning/WebsiteSettings/Gallery/EditGallery/EditGallery";
import AddBrandLogo from "Tuning/WebsiteSettings/BrandLogo/AddBrandLogo/AddBrandLogo";
import EditBrandLogo from "Tuning/WebsiteSettings/BrandLogo/EditBrandLogo/EditBrandLogo";
import AddFooter from "Tuning/WebsiteSettings/Footer/AddFooter/AddFooter";
import EditSocialLink from "Tuning/WebsiteSettings/Footer/EditFooter/EditSocialLink";
import EditTermsAndPrivacy from "Tuning/WebsiteSettings/Footer/EditFooter/EditTermsAndPrivacy";
import AddRoomFeatures from "Tuning/WebsiteSettings/RoomFeature/AddRoomFeatures/AddRoomFeatures";
import EditRoomFeatures from "Tuning/WebsiteSettings/RoomFeature/EditRoomFeatures/EditRoomFeatures";
import EditContactInformatin from "Tuning/WebsiteSettings/ContactInformation/EditContactInformation/EditContactInformation";
import AddContactInformation from "Tuning/WebsiteSettings/ContactInformation/AddContactInformation/AddContactInformation";
import AddHeroSection from "Tuning/WebsiteSettings/HomePageHeroSection/AddHeroSection/AddHeroSection";
import EditHeroSection from "Tuning/WebsiteSettings/HomePageHeroSection/EditHeroSection/EditHeroSection";
import EditServiceLinks from "Tuning/WebsiteSettings/Footer/EditFooter/EditServiceLinks";
import AddServiceLinks from "Tuning/WebsiteSettings/Footer/AddFooter/AddServiceLinks";
import AmenityAdd from "Tuning/WebsiteSettings/Amenity/AmenityAdd/AmenityAdd";
import AmenityEdit from "Tuning/WebsiteSettings/Amenity/AmenityEdit/AmenityEdit";
import WhyChooseUsEdit from "Tuning/WhyChooseUs/WhyChooseUsEdit/WhyChooseUsEdit";
import WhyChooseUsAdd from "Tuning/WhyChooseUs/WhyChooseUsAdd/WhyChooseUsAdd";
import EditAboutUs from "Partials/Universal/Hotels/AboutUs/EditAboutUs/EditAboutUs"
import AddAboutUs from "Partials/Universal/Hotels/AboutUs/AddAboutUs/AddAboutUs"
import SubscriberAdd from "Tuning/CommunicationSettings/SubscribeEmailadd/SubscriberAdd";
import MemberEdit from "Tuning/CommunicationSettings/MemberEdit/MemberEdit"


const TuningRoutes = () => {

  const AddRoutesUrl = (url) => `/:parent/${url}`;
  const EditRoutesUrl = (url) => `/:parent/${url}/:id`;

  const CanCreateRoute = (path, element) => (
    <Route
      key={path}
      path={AddRoutesUrl(path)}
      element={
        <CanAccessThisPage menu_access={['can_create']}>
          {element}
        </CanAccessThisPage>
      }
    />
  );


  const CanEditPageRoute = (path, element) => (
    <Route
      key={path}
      path={EditRoutesUrl(path)}
      element={
        <CanAccessThisPage menu_access={['can_edit']}>
          {element}
        </CanAccessThisPage>
      }
    />
  );

  return [
    <Route key="tuning" exact path="/tuning" element={<Tuning />} />,
    <Route key="common-settings" exact path="/common-settings" element={<CommonSettings />} />,
    <Route key="payment-set" exact path="/payment-set" element={<PaymentSettings />} />,
    <Route key="accounts-setting" exact path="/accounts-setting" element={<AccountSettings />} />,
    <Route key="app" exact path="/app" element={<Apps />} />,
    <Route key="inbox" exact path="/inbox" element={<Inbox />} />,
    <Route key="chat" exact path="/chat" element={<Chat />} />,
    <Route key="calendar" exact path="/calendar" element={<Calendar />} />,
    <Route key="filemanager" exact path="/filemanager" element={<FileManager />} />,
    <Route key="changelog" exact path="/changelog" element={<Changelog />} />,
    <Route key="about-us" exact path="/about-us" element={<AboutUs />} />,
    <Route key="contact-us" exact path="/contact-us" element={<ContactUs />} />,
    <Route key="privacy-policy" exact path="/privacy-policy" element={<PrivacyPolicy />} />,
    <Route key="terms-conditions" exact path="/terms-conditions" element={<TermsConditions />} />,
    <Route key="search" exact path="/search" element={<SearchPage />} />,

    CanCreateRoute("user-add", <UserAdd />),
    CanEditPageRoute("user-edit", <UserEdit />),

    CanCreateRoute("role-add", <RoleAdd />),
    CanEditPageRoute("edit-role", <RoleEdit />),

    CanCreateRoute("add-team-member", <AddTeamMember />),
    CanEditPageRoute("edit-team-member", <TeamMemberEdit />),

    CanCreateRoute("add-gallery", <AddGallery />),
    CanEditPageRoute("edit-gallery", <EditGallery />),

    CanCreateRoute("add-brand-logo", <AddBrandLogo />),
    CanEditPageRoute("edit-brand-logo", <EditBrandLogo />),

    CanCreateRoute("add-social-link", <AddFooter />),
    CanEditPageRoute("edit-social-link", <EditSocialLink />),

    CanCreateRoute("add-room-features", <AddRoomFeatures />),
    CanEditPageRoute("edit-room-features", <EditRoomFeatures />),

    CanEditPageRoute("edit-contact-information", <EditContactInformatin />),

    CanEditPageRoute("menu-edit", <MenuEdit />),

    CanEditPageRoute("currency-edit", <CurrencyEdit />),
    CanCreateRoute("currency-add", <CurrencyAdd />),

    CanEditPageRoute("language-edit", <LanguageEdit />),
    CanEditPageRoute("edit-terms-and-privacy", <EditTermsAndPrivacy />),

    CanCreateRoute("add-contact-information", <AddContactInformation />),
    CanCreateRoute("add-hero-section", <AddHeroSection />),
    CanEditPageRoute("edit-hero-section", <EditHeroSection />),

    CanEditPageRoute("edit-service-links", <EditServiceLinks />),
    CanCreateRoute("add-service-links", <AddServiceLinks />),

    CanCreateRoute("amenity-add", <AmenityAdd />),
    CanEditPageRoute("amenity-edit", <AmenityEdit />),

    CanCreateRoute("whychooseus-add", <WhyChooseUsAdd />),
    CanEditPageRoute("whychooseus-edit", <WhyChooseUsEdit />),

    CanEditPageRoute("edit-about-us", <EditAboutUs />),
    CanCreateRoute("add-about-us", <AddAboutUs />),

    CanCreateRoute("member-email-add", <SubscriberAdd />),
    CanEditPageRoute("member-email-edit", <MemberEdit />),

  ];
};

export default TuningRoutes;